import React from 'react';
import BrowserFrame from './BrowserFrame';
import { Brain, TrendingUp, Sparkles } from 'lucide-react';

const TEAL = '#02857E';

const AtlasInsightsMockup: React.FC<{ className?: string }> = ({ className }) => {
  // sparkline points
  const points = [10, 14, 12, 18, 22, 19, 26, 30, 28, 34, 32, 38];
  const max = Math.max(...points);
  const path = points
    .map((p, i) => {
      const x = (i / (points.length - 1)) * 100;
      const y = 40 - (p / max) * 32;
      return `${i === 0 ? 'M' : 'L'} ${x} ${y}`;
    })
    .join(' ');

  return (
    <BrowserFrame url="app.lanerunner.com/atlas" className={className}>
      <div className="p-5 space-y-3">
        {/* ATLAS chat bubble */}
        <div className="flex items-start gap-3">
          <div
            className="h-9 w-9 rounded-full inline-flex items-center justify-center flex-shrink-0"
            style={{ backgroundColor: TEAL }}
          >
            <Brain className="h-4.5 w-4.5 text-white" />
          </div>
          <div className="flex-1 rounded-2xl rounded-tl-sm bg-gray-50 border border-gray-200 px-4 py-3">
            <div className="text-[10px] font-bold uppercase tracking-wider text-gray-500 mb-1 inline-flex items-center gap-1">
              <Sparkles className="h-3 w-3" style={{ color: TEAL }} /> ATLAS Insight
            </div>
            <div className="text-xs text-gray-800 leading-relaxed">
              Rates on <span className="font-semibold">Dallas → Atlanta (Van)</span> are trending{' '}
              <span className="font-bold" style={{ color: TEAL }}>
                +8.2%
              </span>{' '}
              over 30 days. Best post window: <span className="font-semibold">Tue 6–9 AM CT</span>.
            </div>
          </div>
        </div>

        {/* metric card with sparkline */}
        <div className="rounded-xl border border-gray-200 bg-white p-4">
          <div className="flex items-center justify-between mb-2">
            <div>
              <div className="text-[10px] font-semibold uppercase tracking-wider text-gray-500">
                Lane Rate / Mile
              </div>
              <div className="text-2xl font-bold text-gray-900 mt-0.5">
                $2.86
                <span className="ml-2 text-xs font-semibold inline-flex items-center gap-0.5" style={{ color: TEAL }}>
                  <TrendingUp className="h-3 w-3" /> +8.2%
                </span>
              </div>
            </div>
            <span
              className="px-2 py-1 rounded-full text-[10px] font-bold text-white"
              style={{ backgroundColor: TEAL }}
            >
              HOT
            </span>
          </div>
          <svg viewBox="0 0 100 44" className="w-full h-12" preserveAspectRatio="none">
            <defs>
              <linearGradient id="atlasGrad" x1="0" x2="0" y1="0" y2="1">
                <stop offset="0%" stopColor={TEAL} stopOpacity="0.25" />
                <stop offset="100%" stopColor={TEAL} stopOpacity="0" />
              </linearGradient>
            </defs>
            <path d={`${path} L 100 40 L 0 40 Z`} fill="url(#atlasGrad)" />
            <path d={path} fill="none" stroke={TEAL} strokeWidth="1.5" />
          </svg>
        </div>

        {/* pressure index */}
        <div className="rounded-xl border border-gray-200 bg-white p-4">
          <div className="flex items-center justify-between text-[11px] mb-1.5">
            <span className="font-semibold text-gray-700">Market Pressure Index</span>
            <span className="font-bold" style={{ color: TEAL }}>
              87% Tight
            </span>
          </div>
          <div className="h-2 rounded-full bg-gray-100 overflow-hidden">
            <div className="h-full rounded-full" style={{ width: '87%', backgroundColor: TEAL }} />
          </div>
        </div>
      </div>
    </BrowserFrame>
  );
};

export default AtlasInsightsMockup;
